import * as React from "react"
import RobotLogo from "@web/asset/SVG/RobotLogo"
import cs from "classnames"

import styles from "./Forms.module.scss"

interface Props {
  title: string
  subtitle?: React.ReactNode
  isLeftAligned?: boolean
  isVertical?: boolean

  className?: string
  classes?: {
    logo?: string
    title?: string
    subTitle?: string
  }
}

export const TomboFormAdornment = ({ className, classes, title, subtitle, isLeftAligned, isVertical }: Props) => {
  return (
    <div
      className={cs(
        styles.tomboFormAdornment,
        { [styles.leftAligned]: isLeftAligned, [styles.vertical]: isVertical },
        className
      )}
    >
      <RobotLogo width={30} height={35} className={classes?.logo} />

      <div className={styles.text}>
        <h3 className={classes?.title}>{title}</h3>
        {subtitle && <span className={classes?.subTitle}>{subtitle}</span>}
      </div>
    </div>
  )
}
